import React from "react";
import { Button } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetBranchTallyUploadQuery } from "store/services/branchTallyUploadApi";
import { useAppMeta } from "hooks";
import { BranchTallyUploadDetailContext } from "contexts/BranchTallyUploadDetailContext";
import BranchTallyUploadBasicDetail from "../BranchTallyUploadComponents/BranchTallyUploadBasicDetail";
import BranchTallyUploadAttachmentTab from "../BranchTallyUploadComponents/BranchTallyUploadAttachmentTab";

const BranchTallyUploadDetailScreen = () => {
  const { id } = useParams();
  const { data: branchTallyUploadDetail, isLoading: loadingBranchTallyUpload, error } = useGetBranchTallyUploadQuery(id);
  useAppMeta("Branch Tally Upload Details");
  const breadcrumbs = [
    { title: "Branch Tally Upload", path: "/app/crm/reports/branch-tally-upload/list" },
    { title: "Branch Tally Upload Detail" },
  ];
  return (
    <BranchTallyUploadDetailContext.Provider value={{ branchTallyUploadDetail, loadingBranchTallyUpload }}>
      <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingBranchTallyUpload} headerActions={<Link to={`/app/crm/reports/branch-tally-upload/${id}/edit`}><Button variant="contained">Edit</Button></Link>}>
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <BranchTallyUploadBasicDetail />
          <BranchTallyUploadAttachmentTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </BranchTallyUploadDetailContext.Provider>
  );
};
export default BranchTallyUploadDetailScreen;
